import { SportsEnum } from 'types/generated/client';
import { LocationType, type VenueAddress } from 'utils/shared/coachBuilder';
import { getDefaultActivityImage } from 'utils/shared/getDefaultActivityImage';

export const DEFAULT_VENUE_IMAGE = '/images/tournaments/app/default.png';
export const DEFAULT_VENUE_IMAGE_LOGO = '/images/tournaments/og/detroit.png';
// Shares the court artwork with activity defaults so there is one source for the files.
export const getDefaultVenueImageBySport = (sport?: SportsEnum | null) =>
  getDefaultActivityImage({ sport });

// A typed-in address has no court behind it, so it keeps the address placeholder.
export const getVenueAddressImage = (
  venue: Pick<VenueAddress, 'images' | 'locationType' | 'primarySport'>,
) =>
  venue.images?.[0] ||
  (venue.locationType === LocationType.Custom
    ? undefined
    : getDefaultVenueImageBySport(venue.primarySport));

export function getVenuePrimarySport(venue: {
  hasPickleball?: boolean | null;
  hasPadel?: boolean | null;
  hasTennis?: boolean | null;
}): SportsEnum | null {
  if (venue.hasPickleball) return SportsEnum.Pickleball;
  if (venue.hasPadel) return SportsEnum.Padel;
  if (venue.hasTennis) return SportsEnum.Tennis;
  return null;
}
